import styled from 'styled-components'
import { Box } from '@usap/uicomponents'

const ArticleSection = styled(Box)`
  width: 100%;
  padding-left: 0px;

  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    width: 75%;
    padding-left: 48px;
  }
`

export default ArticleSection
